// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.odo-meter-header {
  font-size: 12px;
  font-weight: bold;
}

.meter-section {
  min-width: 210px;
}
.meter-section .odo-meter-section {
  text-align: right;
}
.meter-section .odo-meter-section ul {
  border-radius: 6px;
  padding: 7px 12px;
  margin-bottom: 5px;
}
.meter-section .type-toggle {
  cursor: pointer;
  margin: 0 5px;
}
.meter-section .device-input,
.meter-section .letter {
  min-width: 15px;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 19px;
  font-size: 14px;
}
.meter-section .device-input {
  margin-left: 2px;
}
.meter-section .odo-meter-action {
  margin-left: 10px;
}
.meter-section time {
  font-size: 10px;
  font-weight: normal;
}
.meter-section .input-meter-section {
  text-align: right;
  white-space: nowrap;
}
.meter-section .input-meter-section ul {
  border-radius: 6px;
  padding: 5px 12px 4px;
  margin-bottom: 5px;
}
.meter-section .device-input {
  font-size: inherit;
  display: inline-block;
  border: 1px solid transparent;
  color: #333;
  font-weight: normal;
  min-width: 20px;
  min-height: 20px;
  line-height: 19px;
  border-radius: 50px;
}
.meter-section .device-input-alt {
  font-weight: bold;
}
.meter-section .list-unstyled .type-toggle {
  line-height: 19px;
  color: inherit;
  display: inline-block;
}
.meter-section .list-unstyled .type-toggle.active {
  font-weight: bold;
}
.meter-section .time-ago {
  display: inline-block;
  margin-top: 5px;
}

.event-section p {
  font-weight: 400;
}

@media (max-width: 1499px) {
  .feature-row-head {
    padding: 6px 10px;
  }
}
@media (max-width: 767px) {
  .feature-row-1 {
    bottom: auto;
  }
}
#signal-strength {
  height: 20px;
  list-style: none;
  overflow: hidden;
}

#signal-strength li {
  width: 5px;
  float: left;
  height: 100%;
  margin-right: 1px;
}

#signal-strength li.sg-5 {
  padding-top: 1px;
}

#signal-strength li.sg-4 {
  padding-top: 5px;
}

#signal-strength li.sg-3 {
  padding-top: 8px;
}

#signal-strength li.sg-2 {
  padding-top: 12px;
}

#signal-strength li.sg-1 {
  padding-top: 15px;
}

#signal-strength li div {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Features/FeatureSection/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,iBAAA;AAAJ;AACI;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AACN;AAEE;EACE,eAAA;EACA,aAAA;AAAJ;AAEE;;EAEE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,eCmDW;ADnDf;AAQE;EACE,gBAAA;AANJ;AAQE;EACE,iBAAA;AANJ;AAQE;EACE,eAAA;EAGA,mBAAA;AARJ;AAWE;EACE,iBAAA;EACA,mBAAA;AATJ;AAUI;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;AARN;AAYE;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,WClCQ;EDmCR,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAVJ;AAWI;EACE,iBAAA;AATN;AAaE;EAEE,iBAAA;EACA,cAAA;EACA,qBAAA;AAZJ;AAaI;EACE,iBAAA;AAXN;AAcE;EACE,qBAAA;EACA,eAAA;AAZJ;;AAgBE;EACE,gBAAA;AAbJ;;AAiBA;EACE;IACE,iBAAA;EAdF;AACF;AAgBA;EACE;IACE,YAAA;EAdF;AACF;AAgBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAdF;;AAgBA;EAEE,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAdF;;AAgBA;EACE,gBAAA;AAbF;;AAeA;EACE,gBAAA;AAZF;;AAcA;EACE,gBAAA;AAXF;;AAaA;EACE,iBAAA;AAVF;;AAYA;EACE,iBAAA;AATF;;AAWA;EACE,YAAA;AARF","sourcesContent":["@import '../../../assets/variables';\n\n.odo-meter-header {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.meter-section {\n  min-width: 210px;\n  .odo-meter-section {\n    text-align: right;\n    ul {\n      border-radius: 6px;\n      padding: 7px 12px;\n      margin-bottom: 5px;\n    }\n  }\n  .type-toggle {\n    cursor: pointer;\n    margin: 0 5px;\n  }\n  .device-input,\n  .letter {\n    min-width: 15px;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    line-height: 19px;\n    font-size: $baseFontSize;\n    //color: #5f5f5f;\n    &-alt {\n      //color: #afafaf;\n      //background: #fff;\n      //border-color: $textColor;\n    }\n  }\n  .device-input {\n    margin-left: 2px;\n  }\n  .odo-meter-action {\n    margin-left: 10px;\n  }\n  time {\n    font-size: 10px;\n    //color: #888;\n    //float: right;\n    font-weight: normal;\n  }\n\n  .input-meter-section {\n    text-align: right;\n    white-space: nowrap;\n    ul {\n      border-radius: 6px;\n      padding: 5px 12px 4px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .device-input {\n    font-size: inherit;\n    display: inline-block;\n    border: 1px solid transparent;\n    color: $textColor;\n    font-weight: normal;\n    min-width: 20px;\n    min-height: 20px;\n    line-height: 19px;\n    border-radius: 50px;\n    &-alt {\n      font-weight: bold;\n    }\n  }\n\n  .list-unstyled .type-toggle {\n    //color: $darkGrey;\n    line-height: 19px;\n    color: inherit;\n    display: inline-block;\n    &.active {\n      font-weight: bold;\n    }\n  }\n  .time-ago {\n    display: inline-block;\n    margin-top: 5px;\n  }\n}\n.event-section {\n  p {\n    font-weight: 400;\n  }\n}\n// responsive\n@media (max-width: 1499px) {\n  .feature-row-head {\n    padding: 6px 10px;\n  }\n}\n@media (max-width: 767px) {\n  .feature-row-1 {\n    bottom: auto;\n  }\n}\n#signal-strength {\n  height: 20px;\n  list-style: none;\n  overflow: hidden;\n}\n#signal-strength li {\n  //display: inline-block;\n  width: 5px;\n  float: left;\n  height: 100%;\n  margin-right: 1px;\n}\n#signal-strength li.sg-5 {\n  padding-top: 1px;\n}\n#signal-strength li.sg-4 {\n  padding-top: 5px;\n}\n#signal-strength li.sg-3 {\n  padding-top: 8px;\n}\n#signal-strength li.sg-2 {\n  padding-top: 12px;\n}\n#signal-strength li.sg-1 {\n  padding-top: 15px;\n}\n#signal-strength li div {\n  height: 100%;\n}\n","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$sidebarWidth : 320px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 50px;\n$headerNavWidth: 50px;\n$headerNavWidthExpended: 200px;\n$headerHeight: 50px;\n$footerHeight: 0;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 3px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: #B2B5C4;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #e0e0e0;\n$lightGrey: #d7d7d7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 1;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 14px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Poppins, sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
